import clsx from 'clsx';
import Imatge from 'components/3catinfo/Imatge';
import Player from 'components/3catinfo/Player';
import Icona from 'components/3catinfo/ui/Icona';
import LogoDirecte from 'components/3catinfo/ui/LogoDirecte';
import LoadingPlayer from 'components/3catinfo/Players/LoadingPlayer';
import { useData } from 'hooks/useData';
import __isEmpty from 'lodash/isEmpty';
import { useEffect, useRef, useState } from 'react';
import styles from './playerminutaminutaudio.module.scss';

export default function PlayerMinutaminutAudio(props) {
    const { autoPlay, id, playerVideoTagId } = props;
    const url_dades =
        'https://api.3cat.cat/arafem?_format=json&cadena=' + id + '&r=yes&tipus=radio&version=1.0&cache=30&https=true&master=yes';

    const { data: dataAudio, getDades } = useData();
    const itemInfo = useRef();
    const itemAudio = useRef();
    const [urlDades, setUrlDades] = useState(url_dades);
    const [infoTitol, setInfoTitol] = useState(false);
    const [isAdPlaying, setIsAdPlaying] = useState(false);
    const [imatgesDirecte, setImatgesDirecte] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const [isDataAudioLoaded, setIsDataAudioLoaded] = useState(false);

    useEffect(() => {
        if (urlDades) {
            getDades(urlDades);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [urlDades]);

    useEffect(() => {
        if (!__isEmpty(dataAudio)) {
            let dataAraFem = _.get(dataAudio, '[0].ara_fem');
            setInfoTitol(dataAraFem?.titol_programa);
            setImatgesDirecte(dataAraFem?.imatges);
            setIsDataAudioLoaded(true);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dataAudio]);

    const playerControllerInstance = (playerController) => {
        playerController.on('loadedmetadata', () => {
            setIsLoading(false);
        });
    };

    const stylesInfo = clsx({
        [styles.info]: true,
        [styles.ad]: isAdPlaying
    });

    const stylesPlayerAudio = clsx({
        [styles.audio]: true,
        [styles.hidden]: isLoading
    });

    const adPlaying = (ad) => {
        setIsAdPlaying(ad);
    };

    return (
        <>
            <div className={stylesInfo} ref={itemInfo}>
                <div className={styles.imatgeDirecte}>
                    <Imatge
                        imatges={imatgesDirecte}
                        tipus='web_player_poster_background'
                        layout='fill'
                        objectFit='contain'
                        mostrarRecurs={false}
                    />
                </div>
                <div className={styles.infoDirecte}>
                    <div className={styles.logoCanal}>
                        <Icona icona='directes' alt='Directe' className={styles.ico_directe} isBlanc={true} />{' '}
                        <LogoDirecte canal={id} logo='light' className={styles.logoDirecte} />
                    </div>
                    <div className={styles.titolWrapper}>
                        <h2 className={styles.titol}>{infoTitol}</h2>
                    </div>
                </div>
            </div>
            {isLoading && <LoadingPlayer />}
            {isDataAudioLoaded && (
                <div className={stylesPlayerAudio} ref={itemAudio}>
                    <Player
                        playerVideoTagId={playerVideoTagId}
                        id={id}
                        autoPlay={autoPlay}
                        directe={true}
                        tipus='audio'
                        estils='minutaminutAudio'
                        adPlaying={adPlaying}
                        imatges={imatgesDirecte}
                        playerControllerInstance={playerControllerInstance}
                    ></Player>
                </div>
            )}
        </>
    );
}

PlayerMinutaminutAudio.defaultProps = {
    titol: '',
    programa: ''
};
